import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import moment from 'moment'
import FromInput from '../../../../../components/user/from/Input'
// import {
//    LoadingOutlined,
//    DeleteOutlined,
//    EyeOutlined,
//    FilePdfOutlined,
//    EllipsisOutlined
// } from '@ant-design/icons';

import { checkLinkURL } from '../../../../../utils/auth'
import {
   changeFormatdate,
   changeFormatFulldate,
 } from "../../../../../utils/formatdate";
 

 
const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
   //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfile = '';
const format = 'HH:mm';

class Tab6 extends Component {
	state = {
        dataTalbeUploads: [
			{
				
			},
		],
      columns: [
         {
            title: 'ประเภทเอกสาร',
            dataIndex: 'documentType',
            align:'center',
            vertical:'top',
            render: (item, record, index) => {
               return(
                  <>
                  {this.props.detailForm?.studyAttachment[index]?.studyAttachmentTypeName ?
                        <Form.Item label={""} style={{ marginBottom: "0px" }}>
                           {/* { this.props.form.getFieldDecorator("documentType"+index, {
                              initialValue: item ? item : [],
                              // rules:  [{ 
                              //       required: (record.description) || (record.attachFile) ? true : false,
                              //       message: 'กรุณาระบุ ประเภทเอกสาร',
                              // }],
                           })( */}
                              <Select 
                                    style={{ width: "100%" }}
                                    value={this.props.detailForm?.studyAttachment[index]?.studyAttachmentTypeName}
                                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                                    // showSearch
                                   // placeholder="กรุณาระบุ "
                                    // optionFilterProp="children"
                                    disabled={true}
                              >
                                   
                              </Select>
                           {/* )} */}
                        </Form.Item> : ""}
                  </>
               )
            }
         },
         {
               title: 'รายละเอียดเพิ่มเติม',
               dataIndex: 'description',
               vertical:'top',
         align:'center',
               render: (item, record, index) => {
                  return(
                     <>
                     {this.props.detailForm?.studyAttachment[index]?.studyAttachmentDetail ?
                        <FromInput disabled={true}  value={this.props.detailForm?.studyAttachment[index]?.studyAttachmentDetail} required={false} name={"studyAttachmentDetail"}  mode={"text"} /> : ""}
                    
                     </>
                  )
               }
         },
         {
               title: 'เอกสารแนบ',
               dataIndex: '7',
               width:'200px',
               vertical:'top',
               align:'center',
               render: (item, record, index) => {
                  return (
                     <>
                        
                         { this.showMoreFileUploads(index, 'Doc') }
                     
                     </>
                  )
               }
         },
         {
            title: 'วันที่ดำเนินการ',
            dataIndex: '8',
            width:'200px',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               return (
                  <>
                    {this.props.detailForm?.studyAttachment[index]?.createdAt ?
                           <span>{changeFormatFulldate(this.props.detailForm?.studyAttachment[index]?.createdAt )}</span>
                         // " dsd"
                           : ""}
                  </>
               )
            }
      },

         // {
         //       title: 'จัดการ',
         //       dataIndex: '7',
         //       width:'20px',
         //       vertical:'top',
         // align:'center',
         //       render: (item, record, index) => {
         //          return this.showDetailBtnInput(record, index)
         //       }
         // },
      ],
      dataTalbeLength:1,
      preLoadOnsubmit: false,
    }



    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeUploads } = this.state
        return(
            <>
                {
                    dataTalbeUploads.length > 1 ? 
                            <Avatar 
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                style={{ cursor: 'pointer', background:"red" }}
                            />
                    : 
                        <Avatar 
                            shape="square"  
                            icon={<Icon type="delete" />} 
                            className="mr-1 mb-1 bg-red"  
                            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                            style={{ cursor: 'not-allowed' }}
                            disabled={true}
                        />
                }
            </>
        )
    }

    showMoreFileUploads = (arrayId, uploadFile) =>{
      const { formRef , detailForm} = this.props
      
      const { dataTalbeUploads, dataTalbeUploadsDocument, checkModal } = this.state
      // const fields = formRef.current.getFieldsValue()
      // const { studyAttachment } = fields
      // console.log('studyAttachment', studyAttachment)
   
      if(detailForm?.studyAttachment[arrayId].studyFilePath){
            return  <Text 
                        onClick={ () => { this.modalShowFileCreate(detailForm?.studyAttachment[arrayId], 'เอกสาร',arrayId) }} 
                        style={{ cursor:"pointer" }}
                        className="btn-show-fileuploads"
                     >
                           {/* {fileNameShow} */}
                           ดูไฟล์เอกสารแนบ
                     </Text>
          }
      
   }


    modalShowFileCreate = async (dataFile, title,arrayId) =>{
      // var url = URL.createObjectURL(dataFile)
      const reader = new FileReader();
      if( dataFile.studyFileType !== "application/pdf"){
         //  reader.readAsDataURL(dataFile)
         //  reader.onloadend = async (e) => {
         //      var dataURL = reader.result;
         //      await this.setState({
         //          linkNewTab: dataURL
         //      })


   
              Modal.info({
                className:"modalFickIcons",
                title: "ไฟล์อัปโหลดเอกสารแนบ",
                width:"1000px",
                content: (
                   <div>
                      <hr></hr>
                      <div className="mt-4">
                         <Row  gutter={16} type="flex" justify="left" align="top" >
                            <Col span={10} className="mb-3 block_show_file" style={{ display:"block"}}>
                               <div style={{ width:"100%", height: "200px", padding:"10px 55px" }} align="center" className="block-show-image-modal">
                                  <img src={checkLinkURL()+dataFile.studyFilePath} style={{  height:"100%" }} />
                                     <a onClick={()=> this.onClickToNewTab(dataFile.studyFileType,arrayId)} className="icons-show-images">
                                     <Icon type="eye" style={{ color: "#fff" }} />
                                     </a>
                               </div>
                            </Col>
                         </Row>
                      </div>
                   </div>
                ),
                okText: 'ปิด',
                onOk() {},
            });
          
         }
         else{
         //  reader.readAsDataURL(dataFile)
         //  reader.onloadend = async (e) => {
         //      var dataURL = reader.result;
         //      await this.setState({
         //          linkNewTab: dataURL
         //      })
   
              Modal.info({
                className:"modalFickIcons",
                title: "ไฟล์อัปโหลดเอกสารแนบ",
                width:"1000px",
                content: (
                   <div>
                      <hr></hr>
                      <div className="mt-4">
                         <Row  gutter={16} type="flex" justify="left" align="top" >
                            <Col span={10} className="mb-3 block_show_file" style={{ display:"block"}}>
                               <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                                  <iframe style={{ opacity:"0", height:"0" }} style={{ display:"none" }}></iframe>
                                  <a onClick={()=> this.onClickToNewTab(dataFile.studyFileType,arrayId)} className="color-white">
                                     {/* <FilePdfOutlined /><br></br> */}
                                     ดูไฟล์ PDF
                                  </a><br></br> 
                               </div>
                            </Col>
                         </Row>
                      </div>
                   </div>
                ),
                okText: 'ปิด',
                onOk() {},
            });
          };
      }
      onClickToNewTab = (typeFile,arrayId) =>{
         const {detailForm} = this.props
         //const { linkNewTab} = this.state
         if(typeFile !== "application/pdf"){
             var win = window.open();
             win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + checkLinkURL()+detailForm?.studyAttachment[arrayId]?.studyFilePath  + '" style="height:100%"/></div>');
         }else{
             var win = window.open();
             win.document.write('<iframe src="' + checkLinkURL()+detailForm?.studyAttachment[arrayId]?.studyFilePath  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
         }
     }
  

	render() {
		const { match , detailForm} = this.props
        const { getFieldDecorator } = this.props.form
        const { columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, } = this.state

        // console.log('dataTalbeUploads',leaveDayAllData)

		return (
            <Row gutter={16} type="flex" justify="left" align="top" >
            <Col xs={24} md={24} className="pt-0">
                <strong className="color-red">
                   เอกสารแนบ
                </strong>
            </Col>
                                       <Col xs={24} md={24} type="flex" justify="left" align="top" className="pt-4">
                                          {console.log("detailForm?.studyAttachment?.length",detailForm?.studyAttachment?.length)}
                                          <Table
                                                columns={columns}
                                                dataSource={detailForm?.studyAttachment}
                                                pagination={false}
                                                className="mb-3"
                                                bordered
                                                rowCount={detailForm?.studyAttachment?.length}
                                                locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                scroll={{ x: "max-content" }}
                                                // pagination={{ pageSize: dataTalbeUploads.length }}
                                          />
                                          {/* <Button 
                                                style={{ display:"inline-block" }}
                                                type="primary btn-color-default btn-custom btn-clear color-white" 
                                                className="mt-1 mr-2"
                                                onClick={ () => this.showDataInputUploads() }
                                          >
                                                เพิ่มเอกสารแนบ +
                                          </Button> */}
                                       </Col>
                                                  
        </Row>



		)
	}
}

Tab6.defaultProps = {
	autoFocus: false
}
Tab6.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedTab6 = Form.create()(Tab6)

export default withApollo(WrappedTab6)